import script from "./AddCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCompany.vue?vue&type=script&setup=true&lang=js"

import "./AddCompany.vue?vue&type=style&index=0&id=7446ea9c&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7446ea9c"]])

export default __exports__